import React from 'react';

const ConfirmModal = ({ 
  open, 
  title = 'Are you sure?', 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Yes', 
  cancelText = 'Cancel', 
  loading,
  response,
  showResponseOnly = false
}) => {
  if (!open) return null;
  
  const isSuccess = response?.success;
  const hasResponse = response && response.message;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6 relative animate-modal-scale-in">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
        
        {/* Show original message if not showing only response */}
        {!showResponseOnly && message && (
          <p className="text-gray-600 mb-4">{message}</p>
        )}
        
        {/* Show response message if available */}
        {hasResponse && (
          <div className={`mb-4 p-3 rounded-lg ${isSuccess ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
            <div className="flex items-start gap-2">
              {isSuccess ? (
                <svg className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              ) : (
                <svg className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )}
              <p className={`text-sm ${isSuccess ? 'text-green-800' : 'text-red-800'}`}>
                {response.message}
              </p>
            </div>
          </div>
        )}
        
        {/* Show buttons only if not showing response only or if there's an error */}
        {!showResponseOnly || !isSuccess ? (
          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              className="px-4 py-2 border-2 border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200 hover:scale-105 active:scale-95"
            >
              {cancelText}
            </button>
            {/* Hide confirm button if showing response only */}
            {!showResponseOnly && (
              <button
                type="button"
                onClick={onConfirm}
                disabled={loading}
                className="px-4 py-2 border-2 border-transparent rounded-lg text-white font-medium bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 hover:scale-105 active:scale-95"
              >
                {loading ? 'Processing...' : confirmText}
              </button>
            )}
          </div>
        ) : (
          /* Show close button for successful responses when showing response only */
          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 border-2 border-transparent rounded-lg text-white font-medium bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 hover:scale-105 active:scale-95"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
